import { Component, EventEmitter, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CustomModalComponent } from '@/components/custom-modal/custom-modal.component';

@Component({
  selector: 'document-accept-budget-modal',
  imports: [FormsModule, CustomModalComponent],
  templateUrl: './document-accept-budget-modal.component.html'
})
export class DocumentAcceptBudgetModalComponent {
  date = new Date().toISOString().split('T')[0];

  @Output() closeFunction = new EventEmitter<void>();
  @Output() acceptFunction = new EventEmitter<{ type: 'factura' | 'albaran' | 'devolucion', date: string }>();

  accept(type: 'factura' | 'albaran' | 'devolucion') {
    this.acceptFunction.emit({ type, date: this.date });
  }
}
